import React from "react";
import BlockContent from "../blockContent";
import Image from "gatsby-plugin-sanity-image";

const darkcolors = ["Red", "Black"]
export default function FeatureGridSegment({ segment }) {
  return (
    <div className="featuregridSegment" style={{ backgroundColor: segment.segstyle?.bg.value, padding: "50px 0" }}>
      <section className="features-area">
        <div className="container">
          <div className="section-title">
            <h2>Powerful features</h2>
          </div>

          <div className="row">
            {segment.items.map((feature) => (
              <div className="col-sm-12 col-md-6" key={feature._key}>
                <div className="feature_grid_item">
                  {feature.image && <Image asset={feature.image.asset} height={60} alt={feature.title} className="mt-3 mb-3" />}
                  <h3>{feature.title}</h3>
                  <BlockContent blocks={feature.description} />
                </div>
              </div>
            ))}
          </div>
          <div className="row text-center pt-40">
            {segment.button.url && <a href={segment.button.url} className="btn btn-opaque m-auto" style={{ marginTop: "15px" }}>{segment.button.text}</a>}
          </div>
        </div>
      </section>
    </div>
  )
}